import { getBrowseCategories } from '@engage/api-v2';
import { engageApi } from '../lib/singletons';
import { unwrap } from '../lib/unwrap';
import { toFetcher } from './toFetcher';
export var toBrowseCategoryFetchers = function toBrowseCategoryFetchers() {
  var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : engageApi;
  return {
    BrowseCategories: toFetcher(function () {
      return "BrowseCategories";
    }, function (params) {
      return unwrap(function () {
        return getBrowseCategories(api, 'on_demand', params.acceptLanguage, {
          headers: {
            'Peloton-Platform': params.pelotonPlatform
          }
        });
      });
    })
  };
};